import { Banner, BannerMenu, Heading, palette, spacing, } from '@digitools/honest-ui';
import { ApplicationCheckIcon, BeneficiariesIcon, CalendarTimerAltIcon, CalendarXIcon, ClipboardAddIcon, ClipboardTimerIcon, FormsDocumentsIcon, PaperPenIcon, ReportAddIcon, ReportsIcon, StrollerIcon, TeamTreeIcon, UploadDocIcon, WorkDeskIcon, } from '@digitools/honest-ui/icons';
import React from 'react';
import styled from 'styled-components';
import { TEALIUM_EVENT } from '../../../../constants/tealiumConstants';
import useAuthentication from '../../../../hooks/useAuthentication';
import useCustomerConfig from '../../../../hooks/useCustomerConfig';
import useExperience from '../../../../hooks/useExperience';
import useTealium from '../../../../hooks/useTealium';
import useTranslate from '../../../../hooks/useTranslate';
import { Experience } from '../../../../types/Experience';
import { getEnvVariable } from '../../../../utils/envUtils';
import { LandingPageBannerText } from './LandingPageBannerText';
import ViewRequestStatusForm from './ViewRequestStatusForm';
import employeeHero from '../../../../assets/employee-hero.png';
import employerHero from '../../../../assets/employer-hero.png';
const EMPLOYER_SEARCH_BOX_WIDTH = '25.75rem';
const ICON_MAP = {
    'clipboard-clock': <ClipboardTimerIcon />, // ee status, er rsc
    'file-new-claim-leave': <PaperPenIcon />, // cli
    'view-request-status': <CalendarTimerAltIcon />, // ria  // TODO: remove this entry after mlp-ui-service updates
    'calendar': <CalendarTimerAltIcon />, // ria (remains after mlp-ui-service updates)
    'file-confirm': <ApplicationCheckIcon />, // eoi
    'document-upload': <UploadDocIcon />, // doc upload
    'manage-preferences': <BeneficiariesIcon />, // bdm
    'calendar-with-cake': <StrollerIcon />, // rab
    'long-term-disability': <WorkDeskIcon />, // as (ee and er)
    'calendar-marked-dates': <CalendarXIcon />, // ua
    'file-regular': <FormsDocumentsIcon />, // forms (ee and er)
    'employees': <TeamTreeIcon />, // team view
    'file-new-claim-leave-er': <ClipboardAddIcon />, // cli-er, lci
    'report-view': <ReportsIcon />, // view reports
    'report-add': <ReportAddIcon />, // crs
};
const EmployerSearchBox = styled.div `
    width: ${EMPLOYER_SEARCH_BOX_WIDTH};
    max-width: calc(100vw - ${spacing.xl} );
    display: flex;
    flex-direction: column;
    gap: ${spacing.xl};
    padding: ${spacing.xl} ${spacing.xl} ${spacing.xl2} ${spacing.xl2};
    border-radius: var(--radius-xl);
    background: ${palette.garnet500};
`;
export function useBannerMenuItems() {
    const { bannerMenu } = useCustomerConfig();
    const { t } = useTranslate();
    const { trackEvent } = useTealium();
    const trackPageEvent = (itemText) => {
        trackEvent({
            event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
            event_name: itemText.toLowerCase(),
            event_type: TEALIUM_EVENT.EVENT_TYPE.HOME_PAGE,
            event_version: TEALIUM_EVENT.EVENT_TYPE.LANDING_PAGE_BANNER,
        });
    };
    return bannerMenu?.map((link, i) => ({
        key: `${i}-${link.url}`,
        text: t(link.text),
        url: link.externalLink ? getEnvVariable('mlpHomeUrl') + link.url : link.url,
        icon: ICON_MAP[link.iconName],
        linkType: link.externalLink ? 'external' : 'local',
        onClick: () => trackPageEvent(t(link.text)),
        'data-public': true,
    })) ?? [];
}
const LandingPageBanner = ({ showMenu = true }) => {
    const { experience } = useExperience();
    const { user } = useAuthentication();
    const { t } = useTranslate();
    const isStatusER = !!user?.applicationPermissions?.includes('statusER');
    const menuItems = useBannerMenuItems();
    const isEmployer = experience === Experience.EMPLOYER;
    const showForm = isEmployer && isStatusER;
    return (<Banner imageUrl={isEmployer ? employerHero : employeeHero} imageAltText={isEmployer ? t(LandingPageBannerText.erImageAltText) : t(LandingPageBannerText.eeImageAltText)} primaryMessage={<>
          {t(LandingPageBannerText.primaryMessageLine1)}
          <br />
          {t(LandingPageBannerText.primaryMessageLine2)}
        </>} secondaryMessage={t(LandingPageBannerText.secondaryMessage)} variant={isEmployer ? 'ER' : 'EE'} headingLevel='h2' fullBleed bannerMenu={showMenu ? <BannerMenu items={menuItems}/> : undefined}>
      {showForm ? (<EmployerSearchBox>
          <Heading as='h2' weight='regular' visualLevel='h2' dark>
            View status
          </Heading>
          <ViewRequestStatusForm />
        </EmployerSearchBox>) : undefined}
    </Banner>);
};
export default LandingPageBanner;
